import { openMailto } from "@/utils/mailto";
import Hero from "../components/hero";
import emergencyIcon from "@assets/icons/emergencyIcon.svg";
import safeIcon from "@assets/icons/safeIcon.svg";
import whyChooseHero from "@assets/images/why-choose-gaz-hero.svg";
import sustainabilityHero from "@assets/images/sustainability-hero.svg";
import careersHero from "@assets/images/Group-1410087750.svg";
import newsHero from "@assets/images/news-hero.svg";
import contactHero from "@assets/images/Group-1410087705.svg";
import aboutHero from "@assets/images/about-hero.svg";
import governanceHero from "@assets/images/governance-hero.svg";
import complianceHero from "@assets/images/compliance-hero.svg";
import downloadsHero from "@assets/images/downloads-hero.svg";
import {
  WhyChooseGazPage,
  SustainabilityPage,
  CareersPage,
  NewsUpdatesPage,
  ContactPage,
  AboutUsPage,
  CorporateGovernancePage,
  RegulatoryCompliancePage,
  DownloadResourcesPage,
} from "@features/general";

export function PartnersWhyChooseGaz() {
  return (
    <WhyChooseGazPage
      hero={
        <Hero
          data={{
            title:
              "Your Trusted Partner for Safe, Reliable & Smart Gas Solutions.",
            description:
              "At Gaz Investment in Oil and Gas Supply L.L.C. (GAZ), we combine advanced technology, strict safety standards, and exceptional customer service to deliver seamless gas supply and billing solutions across the UAE.",
            image: whyChooseHero,
            buttonText: "Talk to Our Team",
            buttonOnclick: () => openMailto({ subject: "Partner Inquiry" }),
            footerText:
              "Supported by real-time billing, 24/7 emergency response, and secure infrastructure.",
            footerButtonText: "Talk to Our Team",
            footerButtonOnclick: () =>
              openMailto({ subject: "Partner Inquiry" }),
            footerIcon: <img src={safeIcon} alt="" className="w-8 h-8" />,
          }}
        />
      }
    />
  );
}

export function PartnersSustainability() {
  return (
    <SustainabilityPage
      hero={
        <Hero
          data={{
            title: "Cleaner Energy. Safer Operations. Sustainable Tomorrow.",
            description:
              "At GAZ, sustainability is embedded in everything we do — from smart metering and emissions reduction to safety excellence and community engagement.",
            image: sustainabilityHero,
            buttonText: "Learn More",
            buttonOnclick: () =>
              openMailto({ subject: "Sustainability Team Contact" }),
            footerText:
              "Learn more about our sustainability initiatives or get in touch with our team.",
            footerButtonText: "Contact Sustainability Team",
            footerButtonOnclick: () =>
              openMailto({ subject: "Sustainability Team Contact" }),
            footerIcon: <img src={safeIcon} alt="" className="w-8 h-8" />,
          }}
        />
      }
    />
  );
}

export function PartnersCareers() {
  return (
    <CareersPage
      hero={
        <Hero
          data={{
            title: "Join a Company That Powers Safety, Innovation & Community",
            description:
              "At Gaz Investment in Oil and Gas Supply L.L.C. (GAZ), our people are the foundation of our success. We are committed to hiring skilled professionals who share our values of safety, integrity, innovation, and customer service excellence.",
            image: careersHero,
            buttonText: "View Open Positions",
            buttonOnclick: () => {
              document
                .getElementById("job-openings")
                ?.scrollIntoView({ behavior: "smooth" });
            },
            footerText:
              "Explore current openings and start your career with us.",
            footerButtonText: "Apply Now",
            footerButtonOnclick: () =>
              openMailto({ subject: "Job Application" }),
            footerIcon: <img src={safeIcon} alt="" className="w-8 h-8" />,
          }}
        />
      }
    />
  );
}

export function PartnersNewsUpdates() {
  return (
    <NewsUpdatesPage
      hero={
        <Hero
          data={{
            title: "Latest News, Safety Alerts & Company Updates",
            description:
              "Stay informed about new services, tariff updates, safety announcements, community programs, and company developments from Gaz Investment in Oil and Gas Supply L.L.C. (GAZ).",
            image: newsHero,
            buttonText: "Subscribe",
            buttonOnclick: () =>
              openMailto({ subject: "Newsletter Subscription" }),
            footerText:
              "Subscribe to our newsletter for the latest updates and announcements.",
            footerButtonText: "Subscribe Now",
            footerButtonOnclick: () =>
              openMailto({ subject: "Newsletter Subscription" }),
            footerIcon: <img src={safeIcon} alt="" className="w-8 h-8" />,
          }}
        />
      }
    />
  );
}

export function PartnersContact() {
  return (
    <ContactPage
      hero={
        <Hero
          data={{
            title: "We're Always Here for You",
            description:
              "Whether you need help with your bill, want to apply for a new connection, or simply have a question about your gas supply — Gaz Investment in Oil and Gas Supply L.L.C. (GAZ) is here 24 hours a day to support you.",
            image: contactHero,
            buttonText: "Contact Us",
            buttonOnclick: () => openMailto({ subject: "Contact Inquiry" }),
            footerText:
              "Call our 24/7 Emergency Line: 800-GAZ (42747) or report a concern online.",
            footerButtonText: "Report an Emergency",
            footerButtonOnclick: () =>
              openMailto({
                subject: "Emergency Report",
                body: "Emergency Type:\nLocation:\nDescription:\n",
              }),
            footerIcon: <img src={emergencyIcon} alt="" className="w-8 h-8" />,
          }}
        />
      }
    />
  );
}

export function PartnersAboutUs() {
  return (
    <AboutUsPage
      hero={
        <Hero
          data={{
            title: "Powering Safety. Delivering Trust.",
            description:
              "Gaz Investment in Oil and Gas Supply L.L.C. (GAZ) is a UAE licensed engineering and utility management company providing complete LPG / SNG gas supply, metering, billing, and maintenance solutions.",
            image: aboutHero,
            buttonText: "View Our Brochure",
            buttonOnclick: () =>
              openMailto({
                subject: "Request: Company Brochure",
                body: "Hello,\n\nI would like to request a copy of the GAZ company brochure.\n\nThank you.",
              }),
            footerText:
              "Our licensed technicians and 24/7 emergency response team are always ready to protect your home and business.",
            footerButtonText: "Report an Emergency Online",
            footerButtonOnclick: () =>
              openMailto({
                subject: "Emergency Report",
                body: "Emergency Type:\nLocation:\nDescription:\n",
              }),
            footerIcon: <img src={emergencyIcon} alt="" className="w-8 h-8" />,
          }}
        />
      }
    />
  );
}

export function PartnersCorporateGovernance() {
  return (
    <CorporateGovernancePage
      hero={
        <Hero
          data={{
            title:
              "Governance Built on Safety. Compliance Anchored in Integrity.",
            description:
              "At Gaz Investment in Oil and Gas Supply L.L.C. (GAZ), we operate under the highest safety, regulatory, and ethical standards.",
            image: governanceHero,
            buttonText: "Learn More",
            buttonOnclick: () =>
              openMailto({ subject: "Corporate Governance Inquiry" }),
            footerText:
              "Our licensed technicians and 24/7 emergency solutions team are always ready to protect your home and business.",
            footerButtonText: "Talk to Our Team",
            footerButtonOnclick: () =>
              openMailto({ subject: "Corporate Governance Inquiry" }),
            footerIcon: <img src={emergencyIcon} alt="" className="w-8 h-8" />,
          }}
        />
      }
    />
  );
}

export function PartnersRegulatoryCompliance() {
  return (
    <RegulatoryCompliancePage
      hero={
        <Hero
          data={{
            title:
              "Your Trusted, Fully Licensed Gas Services Provider in the UAE",
            description:
              "GAZ operates under strict regulatory standards set by Dubai Civil Defense, ESMA, the UAE Fire & Life Safety Code, and the Federal Tax Authority.",
            image: complianceHero,
            buttonText: "Learn More",
            buttonOnclick: () =>
              openMailto({ subject: "Regulatory Compliance Inquiry" }),
            footerText:
              "We provide safe, certified and efficient gas connections to the UAE.",
            footerButtonText: "Talk to Our Team",
            footerButtonOnclick: () =>
              openMailto({ subject: "Regulatory Compliance Inquiry" }),
            footerIcon: <img src={safeIcon} alt="" className="w-8 h-8" />,
          }}
        />
      }
    />
  );
}

export function PartnersDownloadResources() {
  return (
    <DownloadResourcesPage
      hero={
        <Hero
          data={{
            title: "Access All GAZ Documents in One Place",
            description:
              "Download forms, safety guides, tariffs, certificates, and official policies directly from our resource library.",
            image: downloadsHero,
            buttonText: "Search",
            buttonOnclick: () => {},
            footerText:
              "All documents are regularly updated and fully compliant with UAE regulations.",
            footerButtonText: "Request Documents",
            footerButtonOnclick: () =>
              openMailto({ subject: "Document Request" }),
            footerIcon: <img src={safeIcon} alt="" className="w-8 h-8" />,
          }}
        />
      }
    />
  );
}
